import { Navigate, Outlet } from 'react-router-dom';

import { FullPageLoader } from '../components/ui/FullPageLoader';
import { useActivePurchase } from '../lib/hooks/usePurchases';

/** Sits inside `RequireOnboarding`, wrapping `AppShell` — redirects to the
 * package-selection flow if the client has no verified purchase yet
 * (P21-T04). `/app/packages` itself sits OUTSIDE this guard (see App.tsx)
 * so it's reachable both as this redirect's target and later as the
 * "Change Package" entry point for an already-verified client. */
export function RequirePurchase(): JSX.Element {
  const { data: activePurchase, isLoading } = useActivePurchase();

  if (isLoading) return <FullPageLoader label="Loading your account…" />;
  if (!activePurchase) return <Navigate to="/app/packages" replace />;
  return <Outlet />;
}
